// © Microsoft Corporation. All rights reserved.

/**
 * An enumeration of global / fixed connector namespaces
 * Only name spaces that are constant (i.e. not instanced) for the entire SPA lifetime should be listed here
 * NOTE: Keep this list alphabetical
 * NOTE: Left/Right side need to match
 */
export enum ConnectorNamespaces {
    AdminPortalData = "AdminPortalData",
    AdService = "AdService",
    AdsManager = "AdsManager",
    BingImageData = "BingImageData",
    CategoryData = "CategoryData",
    ChromiumPageSettings = "ChromiumPageSettings",
    CoachmarkData = "CoachmarkData",
    ConditionalBannerData = "ConditionalBannerData",
    DailyBriefServiceClient = "DailyBriefServiceClient",
    DisplayAdsManager = "DisplayAdsManager",
    ExperienceLoadedData = "ExperienceLoadedData",
    ExperienceLoadedDataConnector = "ExperienceLoadedDataConnector",
    ExperienceTrackerCommunityData = "ExperienceTrackerCommunityData",
    ExperienceTrackerContentToolsData = "ExperienceTrackerContentToolsData",
    ExperienceTrackerData = "ExperienceTrackerData",
    ExperienceTrackerEdgeData = "ExperienceTrackerEdgeData",
    ExperienceTrackerEdgeNextData = "ExperienceTrackerEdgeNextData",
    ExperienceTrackerFinanceData = "ExperienceTrackerFinanceData",
    ExperienceTrackerFirstPartyData = "ExperienceTrackerFirstPartyData",
    ExperienceTrackerHomePageData = "ExperienceTrackerHomePageData",
    ExperienceTrackerHubData = "ExperienceTrackerHubData",
    ExperienceTrackerMicrosoftNewsData = "ExperienceTrackerMicrosoftNewsData",
    ExperienceTrackerMMXData = "ExperienceTrackerMMXData",
    ExperienceTrackerOfficeData = "ExperienceTrackerOfficeData",
    ExperienceTrackerQnaData = "ExperienceTrackerQnaData",
    ExperienceTrackerRecipesData = "ExperienceTrackerRecipesData",
    ExperienceTrackerWidgets = "ExperienceTrackerWidgets",
    ExperienceTrackerShoppingData = "ExperienceTrackerShoppingData",
    ExperienceTrackerTrafficData = "ExperienceTrackerTrafficData",
    ExperienceTrackerTravelData = "ExperienceTrackerTravelData",
    ExperienceTrackerUgcData = "ExperienceTrackerUgcData",
    ExperienceTrackerViewsData = "ExperienceTrackerViewsData",
    ExperienceTrackerWeatherData = "ExperienceTrackerWeatherData",
    ExperienceTrackerWeatherDataConnector = "ExperienceTrackerWeatherDataConnector",
    ExperienceTrackerWindowsNewsAndInterestsData = "ExperienceTrackerWindowsNewsAndInterestsData",
    ExperienceTrackerWindowsData = "ExperienceTrackerWindowsData",
    ExperienceTrackerWindowsShellData = "ExperienceTrackerWindowsShellData",
    FeedbackData = "FeedbackData",
    HubPageSettings = "HubPageSettings",
    IrisData = "IrisData",
    LayoutPreferenceData = "LayoutPreferenceData",
    LocationFeed = "LocationFeed",
    MarketSelector = "MarketSelector",
    MilestoneData = "MilestoneData",
    MsccCookieBannerData = "MsccCookieBannerData",
    MsNewsPageSettings = "MsNewsPageSettings",
    NavigationData = "NavigationData",
    OfficeSharedData = "OfficeSharedData",
    OneTrustCookieConsentData = "OneTrustCookieConsentData",
    PageClickTrackerData = "PageClickTrackerData",
    PageLayout = "PageLayout",
    PageSettingsData = "PageSettingsData",
    PlacementManager = "PlacementManager",
    PoweredByData = "PoweredByData",
    Preload = "Preload",
    QnaFeedService = "QnaFeedService",
    RewardsData = "RewardsData",
    SharedState = "SharedState",
    SportsData = "SportsData",
    SportsDataUtils = "SportsDataUtils",
    SportsOlympicData = "SportsOlympicData",
    Telemetry = "Telemetry",
    ShellNewTabData = "ShellNewTabData",
    SmartListSharedData = "SmartListSharedData",
    TelemetryData = "TelemetryData",
    TelemetryDataEdgeChromium = "TelemetryDataEdgeChromium",
    TelemetryEdgeChromium = "TelemetryEdgeChromium",
    TopicData = "TopicData",
    TopSitesLayoutData = "TopSitesLayoutData",
    VerticalPropertyData = "VerticalPropertyData",
    VideoDataManager = "VideoDataManager",
    ViewsNativeAd = "ViewsNativeAdConnector",
    ViewsFullPage = "ViewsFullPage",
    WeatherData = "WeatherData",
    WeatherMapData = "WeatherMapData",
    FinanceData = "FinanceData",
    SocialData = "SocialData",
    WindowsNewsAndInterestsData = "WindowsNewsAndInterestsData",
    WindowsShellData = "WindowsShellData",
    WindowsPageSettings = "WindowsPageSettings"
}
